export const convertClassicDate = (date, weekday=false) => {
  const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const newDate = new Date(date)
  const month = newDate.toLocaleString('default', { month: 'long' })
  const day = newDate.getDate()
  const year = newDate.getFullYear()
  return `${weekday ? weekdays[newDate.getDay()] + ', ' : ''}${month} ${day}, ${year}`
}

export const reformatDateToMonthDayYear = (date) => {
  return new Date(`${date?.toISOString().split('T')[0].split('-')[1]}-${date?.toISOString().split('T')[0].split('-')[2]}-${date?.toISOString().split('T')[0].split('-')[0]}`)
}

export const reformatDateToMonthDayYearWithTime = (date) => {
  return new Date(`${date?.toISOString().split('T')[0].split('-')[1]}-${date?.toISOString().split('T')[0].split('-')[2]}-${date?.toISOString().split('T')[0].split('-')[0]} ${date?.toTimeString().split(' ')[0]}`)
}

export const convertDateToInputDateAndTimeFormat = (date) => {
  return `${convertDateToInputFormat(reformatDateToMonthDayYearWithTime(date))} ${convertDateToTimeInputFormat(reformatDateToMonthDayYearWithTime(date))}`
}

export const convertDateToInputFormat = (date) => {
  const year = date?.getFullYear()
  const month = date?.getMonth() + 1
  const day = date?.getDate()
  return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
}

export const convertInputDateToDateFormat = (string) => {
  return new Date(`${string.split('-')[1]}-${string.split('-')[2]}-${string.split('-')[0]}`)
}

export const convertInputDateToDateAndTimeFormat = (string) => {
  return new Date(`${string.split('-')[1]}-${string.split('-')[2]}-${string.split('-')[0]} ${getTimeFromDate(new Date(string))}`)
}

export const convertDateToTimeInputFormat = (date) => {
  return `${date?.toTimeString().split(' ')[0]}`
}

export const getTimeFromDate = (date) => {
  return date?.toTimeString().slice(0, 5)
}